var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgArrowrightgray(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icon"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Union",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.8759 9.19271C11.1688 8.89982 11.6437 8.89982 11.9366 9.19271L17.1218 14.3779C17.4147 14.6708 17.4147 15.1457 17.1218 15.4386L11.9366 20.6237C11.6437 20.9166 11.1688 20.9166 10.8759 20.6237C10.583 20.3309 10.583 19.856 10.8759 19.5631L15.5308 14.9082L10.8759 10.2534C10.583 9.96048 10.583 9.4856 10.8759 9.19271Z",
    fill: "#B8B5C3"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowrightgray);
export default __webpack_public_path__ + "static/media/arrowrightgray.0dec8cfae1933e9a23fb8d489d745448.svg";
export { ForwardRef as ReactComponent };